"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentCoin = exports.getCoinInfo = exports.getAssetsData = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.function.name.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _index = require("@/model/assets/index");

// import {
//   showZMessage
// } from '@/components/dialog/message';
// import {
//   getCoinList,
//   getAssetsList
// } from '@/model/assets/index';
var VERSION = 5;
var __version = "3.4.2"; // 获取币种列表 (请求)

var $getCoinList = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var req, _yield$getCoinList, data, key;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            req = {
              __version: "3.4.3",
              __channel: "2"
            };
            _context.next = 3;
            return (0, _index.getStaticCoinList)(req);

          case 3:
            _yield$getCoinList = _context.sent;
            data = _yield$getCoinList.data;

            for (key in data) {
              data[key].itemDetail.capital_name = data[key].itemDetail.name.toUpperCase();
            } // localStorage.setItem('coinDataVersion', VERSION);
            // sessionStorage.setItem('coinData', JSON.stringify(data));


            return _context.abrupt("return", data);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function $getCoinList() {
    return _ref.apply(this, arguments);
  };
}(); // 获取币种列表（本地|请求）


var getCoinInfo = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var coinData;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (_jsCookie.default.get("topcredit_exchange_t")) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            _context2.next = 4;
            return $getCoinList();

          case 4:
            coinData = _context2.sent;
            return _context2.abrupt("return", coinData);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getCoinInfo() {
    return _ref2.apply(this, arguments);
  };
}(); // 获取资产列表


exports.getCoinInfo = getCoinInfo;

var getAssetsData = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var _yield$getAssetsList, data;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (_jsCookie.default.get("topcredit_exchange_t")) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            _context3.next = 4;
            return (0, _index.getAssetsList)({});

          case 4:
            _yield$getAssetsList = _context3.sent;
            data = _yield$getAssetsList.data;
            return _context3.abrupt("return", data);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getAssetsData() {
    return _ref3.apply(this, arguments);
  };
}(); // 获取当前选择的币种


exports.getAssetsData = getAssetsData;

var getCurrentCoin = function getCurrentCoin() {
  return localStorage.currentCoin ? JSON.parse(localStorage.currentCoin) : "";
}; // const getCurrentCoin = () => {
//   return sessionStorage.currentCoin
//     ? JSON.parse(sessionStorage.currentCoin)
//     : "";
// };


exports.getCurrentCoin = getCurrentCoin;